import { filterAccountNumbersByCloudProvider } from "../../../CloudProviderContext";

export const isCustomerActive = (customer) =>
  customer?.is_active === true ||
  customer?.isActive === true ||
  customer?.active === true;

export const getCustomerDisplayName = (customer) =>
  customer?.customer_name || customer?.orgcode || "this customer";

/** Account entries from margin summary customer row */
export const getCustomerAccountEntries = (customer) => {
  const rawAccountNumbers = customer?.account_numbers;

  if (Array.isArray(rawAccountNumbers)) {
    return rawAccountNumbers.map((accountNumber) => ({
      accountNumber: String(accountNumber || ""),
      company: customer?.customer_name || "",
      status: "SHADOW",
    }));
  }

  if (rawAccountNumbers && typeof rawAccountNumbers === "object") {
    return Object.entries(rawAccountNumbers).map(([key, account]) => ({
      accountNumber: String(account?.account_number || key || ""),
      company: String(account?.company || customer?.customer_name || ""),
      status: String(account?.status || "SHADOW"),
    }));
  }

  return [];
};

export const getCustomerAccountNumbers = (customer) =>
  getCustomerAccountEntries(customer)
    .map((acc) => acc.accountNumber)
    .filter(Boolean);

export const getAwsCustomerAccountNumbers = (customer, cloudTypeLookup) =>
  filterAccountNumbersByCloudProvider(
    getCustomerAccountNumbers(customer),
    "AWS",
    cloudTypeLookup
  );

export const getAwsCustomerAccountCount = (customer, cloudTypeLookup) =>
  getAwsCustomerAccountNumbers(customer, cloudTypeLookup).length;

export const getAwsCustomerAccountEntries = (customer, cloudTypeLookup) => {
  const awsAccountNumbers = new Set(
    getAwsCustomerAccountNumbers(customer, cloudTypeLookup)
  );
  return getCustomerAccountEntries(customer).filter((acc) =>
    awsAccountNumbers.has(acc.accountNumber)
  );
};

/** Merge org-wide accounts with this customer's assigned accounts from margin data */
export const mergeOrgAccountsWithCustomer = (apiAccounts, customer) => {
  const map = new Map();

  (apiAccounts || []).forEach((acc) => {
    if (acc?.accountNumber) {
      map.set(acc.accountNumber, acc);
    }
  });

  getCustomerAccountEntries(customer).forEach((acc) => {
    if (acc.accountNumber && !map.has(acc.accountNumber)) {
      map.set(acc.accountNumber, acc);
    }
  });

  return Array.from(map.values());
};
